<script setup lang="ts">
import logoImg from '@/assets/logo.png'

const PHONES = ['+8801716436241', '+8801951144402', '+8801951144410']
const EMAIL = 'info@chinatourdeal.com'
const WHATSAPP_GROUP = 'https://chat.whatsapp.com/J0Qcxot6defA2Vf145eh4K'

const OFFICES = [
  {
    name: 'Bangladesh office',
    lines: ['2nd floor, Ka-24/4, Sarkar Market (opposite Syed Ali Super Market)', 'Bashundhara R/A Main Gate, Dhaka-1229'],
  },
  {
    name: 'China office',
    lines: ['Beijing TripTricks Travel Co. Ltd', 'Bldg 2, No.66 Yanfu Rd, Fangshan, Beijing 102400'],
  },
  { name: 'Liaison offices', lines: ['India, Thailand, Nepal'] },
]

// Pages every user of the app can open
const LINKS = [
  { to: '/packages', label: 'Tour packages' },
  { to: '/package-requests/create', label: 'Request a custom package' },
  { to: '/booking-vouchers', label: 'Booking vouchers' },
  { to: '/hotel-vouchers', label: 'Hotel vouchers' },
  { to: '/invoices', label: 'Invoices' },
  { to: '/finance', label: 'Finance' },
]

// +8801716436241 → +880 1716 436241, easier to read and to dial
const formatPhone = (phone: string) => phone.replace(/^(\+880)(\d{4})(\d+)$/, '$1 $2 $3')

const year = new Date().getFullYear()
</script>

<template>
  <footer class="ft">
    <div class="ui-shell">
      <div class="ft-grid">
        <!-- Brand -->
        <div class="ft-brand">
          <RouterLink to="/home" class="ft-logo" aria-label="China Tour Deal, home">
            <img :src="logoImg" alt="China Tour Deal">
          </RouterLink>
          <p>Tour packages in China for travel agencies, at agency prices and under your own brand.</p>
          <a class="ft-whatsapp" :href="WHATSAPP_GROUP" target="_blank" rel="noopener noreferrer">
            <i class="fab fa-whatsapp" aria-hidden="true"></i>Join our WhatsApp group
          </a>
        </div>

        <!-- Offices -->
        <div class="ft-col">
          <h2>Our offices</h2>
          <ul class="ft-offices">
            <li v-for="office in OFFICES" :key="office.name">
              <i class="fa fa-map-marker-alt" aria-hidden="true"></i>
              <div>
                <strong>{{ office.name }}</strong>
                <span v-for="line in office.lines" :key="line">{{ line }}</span>
              </div>
            </li>
          </ul>
        </div>

        <!-- Support -->
        <div class="ft-col">
          <h2>Support</h2>
          <ul class="ft-contact">
            <li v-for="phone in PHONES" :key="phone">
              <a :href="`tel:${phone}`"><i class="fa fa-phone-alt" aria-hidden="true"></i>{{ formatPhone(phone) }}</a>
            </li>
            <li>
              <a :href="`mailto:${EMAIL}`"><i class="fa fa-envelope" aria-hidden="true"></i>{{ EMAIL }}</a>
            </li>
          </ul>
        </div>

        <!-- Quick links -->
        <div class="ft-col">
          <h2>Go to</h2>
          <ul class="ft-links">
            <li v-for="link in LINKS" :key="link.to">
              <RouterLink :to="link.to">{{ link.label }}</RouterLink>
            </li>
          </ul>
        </div>
      </div>

      <div class="ft-bottom">
        <span>© {{ year }} China Tour Deal</span>
        <span>A concern of Trip Tricks</span>
      </div>
    </div>
  </footer>
</template>

<style scoped>
@import url("./AppFooter.css");
</style>
